import React from 'react';
import styles from './style.module.css';
import StepFiveForm from '../../components/forms/step-five';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Money Now</p>
        <h2 className={styles.mainTitle}>What I have</h2>
        <p className={styles.text}>Every journey starts somewhere. So set the stage: <strong>where are you today with your money?</strong> Then we'll set your goals together.</p>
        <StepFiveForm/>
    </div>
);
